export { default } from './WelcomeNextShipment';
